export const organizationRegistrationTranslations = {
  lv: {
    offerQuestion: 'Vai vēlaties izveidot jaunu organizāciju?',
    offerText:
      'Šobrīd strādājat kā individuāls prakses vadītājs. Organizācijas kontā varat pievienot citus lietotājus un vienuviet pārvaldīt vakances, praktikantus un līgumus.',
    offerAction: 'Izveidot organizāciju',
    formTitle: 'Jauna organizācija',
    formSubtitle:
      'Ievadiet organizācijas datus un izvēlieties lietotāju skaitu. Pēc apmaksas organizācija tiks izveidota un jūs kļūsiet par tās administratoru.',
    details: 'Organizācijas dati',
    seats: 'Lietotāji un cena',
    optional: 'neobligāts',
    required: 'Lauks ir obligāts',
    fields: {
      orgName: 'Nosaukums',
      billingName: 'Paraksttiesīgā persona',
      regNo: 'Reģistrācijas numurs',
      vatNo: 'PVN numurs',
      orgPhone: 'Tālrunis',
      country: 'Valsts',
      orgLegalAddress: 'Juridiskā adrese',
    },
    columns: {
      item: 'Pozīcija',
      quantity: 'Skaits',
      price: 'Cena',
      vat: 'PVN',
      sum: 'Summa',
    },
    items: {
      Org: 'Edy365.com Pro (1 administrators + 1 prakses vadītājs)',
      OrgUser: 'Papildu prakses vadītāji',
      OrgAdmin: 'Papildu administratori',
    },
    total: 'Kopā mēnesī',
    pay: 'Maksāt ar karti',
    registerError: 'Neizdevās sākt maksājumu',
    processing: 'Apstrādājam maksājumu…',
    paid: 'Organizācija izveidota',
    processErrorTitle: 'Maksājumu neizdevās apstrādāt',
    processError: 'Mēģiniet vēlreiz vai sazinieties ar atbalstu.',
    invalidReturn: 'Maksājuma atgriešanās saite nav derīga.',
    backToProfile: 'Atpakaļ uz organizācijas profilu',
  },
  en: {
    offerQuestion: 'Do you want to create a new organization?',
    offerText:
      'You are working as an individual supervisor. An organization account lets you add other users and manage vacancies, interns and agreements in one place.',
    offerAction: 'Create organization',
    formTitle: 'New organization',
    formSubtitle:
      'Enter the organization details and choose the number of users. After payment the organization is created and you become its administrator.',
    details: 'Organization details',
    seats: 'Users and price',
    optional: 'optional',
    required: 'This field is required',
    fields: {
      orgName: 'Name',
      billingName: 'Authorized signatory',
      regNo: 'Registration number',
      vatNo: 'VAT number',
      orgPhone: 'Phone',
      country: 'Country',
      orgLegalAddress: 'Legal address',
    },
    columns: {
      item: 'Item',
      quantity: 'Quantity',
      price: 'Price',
      vat: 'VAT',
      sum: 'Sum',
    },
    items: {
      Org: 'Edy365.com Pro (1 administrator + 1 supervisor)',
      OrgUser: 'Additional supervisors',
      OrgAdmin: 'Additional administrators',
    },
    total: 'Total per month',
    pay: 'Pay by card',
    registerError: 'Could not start the payment',
    processing: 'Processing the payment…',
    paid: 'The organization has been created',
    processErrorTitle: 'The payment could not be processed',
    processError: 'Try again or contact support.',
    invalidReturn: 'The payment return link is not valid.',
    backToProfile: 'Back to the organization profile',
  },
}
